import React, { useEffect } from 'react';

import { BaseLandingPage } from '../base/BaseLandingPage';
import { useSelector } from 'react-redux';
import { FeaturesState } from 'common/features/featuresReducer';
import { useSearchGridStyles } from 'features/search/components/hooks';
import { TopPicksCard } from 'features/search/components/TopPicksCard';
import { SearchGrid } from 'components/search-grid/SearchGrid';
import { useScrollToTop } from 'hooks/useScrollToTop';
import { and } from 'common/utils/searchFilters';
import { brandsOnBonusFilter } from 'common/api/search/getBrandsOnBonus';
import { withAuth } from 'features/auth/components/withAuth';
import { Routes } from 'routes';
import { EarnTypeConstructorFilter } from 'common/api/constructor/util';
import { selectIsConstructorBrowseEnabledWeb } from 'common/features/store/duck/ffs';
import { useHistory } from 'react-router-dom';
import { UserAuthState, selectUserAuthState } from 'common/features/store/duck/account/duck';

export const BrandsOnBonus = () => {
    const { pageBrands, loading: brandsLoading } = useSelector(
        (state: FeaturesState) => state.store.searchGrid
    );
    const [searchGridStyles] = useSearchGridStyles<'325', '280'>('325', '280');
    const userAuthState = useSelector(selectUserAuthState);
    const isConstructorEnabled = useSelector(selectIsConstructorBrowseEnabledWeb);
    const isAuthenticated = userAuthState === UserAuthState.AUTHENTICATED;
    useScrollToTop();

    const filter =
        isConstructorEnabled && isAuthenticated
            ? and(
                  brandsOnBonusFilter,
                  `EarningsType/any(t: t eq '${EarnTypeConstructorFilter.GiftCards}')`
              )
            : brandsOnBonusFilter;

    return (
        <BaseLandingPage
            firebaseConfigKey="brands_on_bonus_hero_id"
            filter={filter}
            renderBonusSwitch={false}
        >
            <SearchGrid
                ItemComponent={TopPicksCard}
                items={pageBrands}
                isLoading={brandsLoading}
                containerStyles={searchGridStyles}
            />
        </BaseLandingPage>
    );
};

export const ShopOnlineBrandsOnBonus = withAuth(Routes.ShopOnlineOnBonus)(() => {
    const { pageBrands, loading: brandsLoading } = useSelector(
        (state: FeaturesState) => state.store.searchGrid
    );
    const [searchGridStyles] = useSearchGridStyles<'325', '280'>('325', '280');
    const isConstructorEnabled = useSelector(selectIsConstructorBrowseEnabledWeb);
    const history = useHistory<any>();
    useScrollToTop();

    useEffect(() => {
        if (isConstructorEnabled === false) {
            history.push(Routes.OnBonus);
        }
    }, [isConstructorEnabled]);

    const filter = and(
        brandsOnBonusFilter,
        `EarningsType/any(t: t eq '${EarnTypeConstructorFilter.ShopOnline}')`
    );

    return (
        <BaseLandingPage
            firebaseConfigKey="brands_on_bonus_hero_id"
            filter={filter}
            renderBonusSwitch={false}
        >
            <SearchGrid
                ItemComponent={TopPicksCard}
                items={pageBrands}
                isLoading={brandsLoading}
                containerStyles={searchGridStyles}
            />
        </BaseLandingPage>
    );
});
